export const postNewsletter = async (newsletterUrl: string, emailInput: string, source: string, interests = "") => {
    try {
        await fetch(`${newsletterUrl}?email=${encodeURIComponent(emailInput?.trim())}&bron=${source}&${interests}`, {
            mode: "no-cors",
        })
    } catch (error) {
        console.log(error)
    }
}
